import { render, staticRenderFns } from "./exampleCode.vue?vue&type=template&id=5a407cb3&scoped=true&"
import script from "./exampleCode.vue?vue&type=script&lang=js&"
export * from "./exampleCode.vue?vue&type=script&lang=js&"
import style0 from "./exampleCode.vue?vue&type=style&index=0&id=5a407cb3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a407cb3",
  null
  
)

export default component.exports